import * as yup from 'yup';

function email(formatMessage) {
  return yup
    .string()
    .email(
      formatMessage({
        id: 'EMAIL_FIELD_IS_INVALID',
        defaultMessage: 'Email is invalid',
      }),
    )
    .required(
      formatMessage({
        id: 'EMAIL_FIELD_IS_REQUIRED',
        defaultMessage: 'Email is required',
      }),
    );
}

function phones(formatMessage) {
  return yup.array().of(
    yup.object().shape({
      phoneNumber: yup.string().required(
        formatMessage({
          id: 'FIELD_REQUIRED',
          defaultMessage: 'Phone number is required',
        }),
      ),
    }),
  );
}

const validationSchema = formatMessage =>
  yup
    .object({
      email: email(formatMessage),
      phones: phones(formatMessage),
    })
    .required();

export default validationSchema;
